import React, { useEffect, useState, memo, useCallback } from "react";

import { Input } from "reactstrap";

interface InputPasswordProps {
  value: null | string;
  id: string;
  placeholder: null | string;
  onChange: (value: string) => void;
  required: false | boolean;
  maxLength: null | number;
  className: null | string;
  autoFocus: false | boolean;
}

const InputPassword = memo(({ id, placeholder, value, onChange, required, maxLength, className, autoFocus}: InputPasswordProps) => {
    const [text, setText] = useState<string>(value || '');
    const [passwordShown, setPasswordShown] = useState(false);

    const togglePassword = useCallback(() => {
        setPasswordShown(prev => !prev);
    }, []);

    useEffect(() => {
        setText(value);
    }, [value]);

    const handleChange = useCallback((e: any) => {
        const newText = e.target.value;
        setText(newText);
        onChange(newText);
    }, [onChange]);

    return (
        <div className="position-relative auth-pass-inputgroup">
            <Input
                type={passwordShown ? "text" : "password"}
                className={className || "form-control"}
                id={id}
                placeholder={placeholder || ""}
                value={text || ''}
                onChange={handleChange}
                maxLength={maxLength || null}
                autoComplete="off"
                required={required}
                autoFocus={autoFocus}
            />
            <button
                className="btn btn-link position-absolute top-0 end-0 text-decoration-none text-muted"
                type="button"
                tabIndex={-1}
                onClick={togglePassword}
            >
                <i className="ri-eye-off-fill align-middle"/>
            </button>
        </div>
    );
});

InputPassword.displayName = 'InputPassword';

export default InputPassword;
